import { roundNumber } from '@/domain/mitarbeiter/features/feiertagskonto/shared';
import z from 'zod';

export function UebertragAusVorjahrSchema() {
  const schema = z
    .string()
    .regex(
      /^-?\d+(?:[,.]\d+)?$/,
      'Gib einen Zahlenwert zwischen -99,5 und 99,5 ein.',
    )
    .transform((value) => Number(value.replace(',', '.')))
    .pipe(z.number().min(-99.5).max(99.5))
    .transform(roundNumber);
  return { schema };
}
